import React from 'react';
import { Button, Tooltip, Tag,Table,Empty } from 'antd';


export default function ResultList(props) {
    return (
        <Table
            bordered={props.bordered === undefined ? false : props.bordered}
            style={{ overflowX: 'auto',whiteSpace:'nowrap' }}
            title={() => (
                <div style={{ width: '100%', textAlign: "right" }}>
                    <div className="custom-options">
                        {
                            props.onExportExcel === undefined ? null :
                                <Button ghost
                                    type="success"
                                    icon="file-excel"
                                    onClick={props.onExportExcel}
                                    style={{ color: '#3fb703' }}
                                    loading={props.loadingExcel}
                                >
                                    Excel
                                </Button>
                        }
                        {
                            props.onExportPdf === undefined ? null :
                                <Button ghost
                                    type="danger"
                                    icon="file-pdf"
                                    hidden={true}
                                    onClick={props.onExportPdf}
                                    style={{ color: '#ff4d4f' }}
                                    loading={props.loadingPdf}
                                >
                                    Pdf
                                </Button>
                        }
             
                
                   
                    </div>
                </div>
            )}
            loading={
                props.pagination.loading ? {
                    tip: "Un momento por favor",
                    size: "large"
                } : false
            }
            size="small"
            rowKey={record => record.id}
            dataSource={props.pagination.data}
            onChange={(pagination, filters, sorter) => {
                props.onChange({
                    page: pagination.current,
                    order: sorter.order,
                    field: sorter.field
                })
            }}
            locale={{
                emptyText: <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="No se encontraron datos."
                />
            }}
            pagination={{
                total: props.pagination.total,
                current: props.pagination.page,
                pageSize: props.pagination.pageSize,
                showTotal: (total) => `${total} Registro(s) encontrado(s).`
            }}

            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                    

                            <Tooltip placement="top" title="Ver">
                                <Button
                                    type="primary"
                                    icon="search"
                                    size={"small"}
                                    hidden={true}
                                    loading={props.loadingVer}
                                    onClick={() => props.onView(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title="Historial">
                                <Button
                             
                                    type="primary"
                                    icon="search"
                                    size={"small"}
                                    onClick={() => props.onHistorial(row)}  
                                />
                            </Tooltip>

            
                        </div>
                    )
                },
                {
                    title: 'Nro Serie',
                    dataIndex: 'nroSerie' ,
                    key: 'nro_serie',
                    render: (value, row) => (
                        <span>{row.nroSerie}-{row.correlativo}</span>
                    ) 
                },
             
                {
                    title: 'Fecha Comprobante',
                    dataIndex: 'fechaStr',
                    key: 'fecha',
                    sorter: true
                },
                {
                    title: 'Nro Comprobante',
                    dataIndex: 'serieDocumentoComprobante',
                    key: 'comprobante',
                    sorter: true
                },
                {
                    title: 'Tipo Comprobante',
                    dataIndex: 'nombreTipoComprobante',
                    key: 'tipoComprobante',
                    sorter: true
                },
                {
                    title: 'Fecha Venc. Comprobante',
                    dataIndex: 'fechaVencemientoStr',
                    key: 'fechaVencemientoStr',
                    sorter: true
                },
                {
                    title: 'Tipo Documento',
                    dataIndex: 'tipoDocumentoCliente',
                    key: 'tipoDocumento',
                    sorter: true
                },
                {
                    title: 'Nro Documento',
                    dataIndex: 'numeroDocumentoCliente',
                    key: 'documento',
                    sorter: true
                },
                {
                    title: 'Proveedor',
                    dataIndex: 'razonSocialCliente',
                    key: 'cliente',
                    sorter: true
                },
                {
                    title: 'Moneda Original',
                    dataIndex: 'moneda',
                    key: 'moneda',
                    sorter: true
                },
                {
                    title: 'Total',
                    dataIndex: 'totalSoles',
                    key: 'totalSoles',
                    sorter: true,
                    align: 'right',
                    render: (data) => (
                       <span>{data.toFixed(2)}</span>
                   ) 
                },


                {
                    title: 'Pagado',
                    className: 'parent-group parent-group-2',
                    children: [
                        {
                            title: 'Soles',
                            dataIndex: 'canceladoSoles',
                            key: 'canceladoSoles',
                            className: 'parent-group parent-group-2',

                            align: 'right',
                             render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            ) 
                        },
                        {
                            title: 'Dólares',
                            dataIndex: 'canceladoDolares',
                            key: 'canceladoDolares',
                            className: 'parent-group parent-group-2',

                            align: 'right',
                             render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            ) 
                        }
                    ]
                },

                {
                    title: 'Saldo a Pagar',
                    dataIndex: 'saldoSoles',
                    key: 'saldoSoles',
                    sorter: true,
                    align: 'right',
                    render: (data) => (
                       <span>{data.toFixed(2)}</span>
                   ) 
                },
   
                {
                    title: 'Tipo Cambio',
                    dataIndex: 'tipoCambio',
                    className: 'parent-group parent-group-2',
                    key: 'tipoCambio',
                    render: (data) => (
                        <span>{data.toFixed(3)}</span>
                    )
                },
                {
                    title: 'Estado',
                    dataIndex: 'idCuentasEstado',
                    key: 'flag',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',
                    render: (value,row) => {
                        return (<div className="custom-options" >
                            {(() => {
                                switch (value) {
                                    case 1: //registado
                                        return <Tag color={"red"}>{row.nombreCuentasEstado}</Tag>;
                                    case 2://ANULADA
                                        return <Tag color={"green"}>{row.nombreCuentasEstado}</Tag>;
                                    case 3://APERTURADA
                                        return <Tag color={"green"}>{row.nombreCuentasEstado}</Tag>;
                                    case 4://CERRADO
                                        return <Tag color={"orange"}>{row.nombreCuentasEstado}</Tag>;
                                    default:
                                        return null;
                                }
                            })()}

                        </div>)
                    }
                }
            ]}
        />
    );
}